module.exports = __webpack_public_path__ + "img/turbo-features2.5865b139.png";